
export class AssetTempRecoSave {
    inventoryId: number;
    assetTempId: number;
    assetId: number;
}